import {useIsAutodetectTimeZone} from '../../../hooks/useIsAutodetectTimeZone'
import type {ChangeId} from '../../../types'
import {displayDate} from '../../../utils/dateTimeUtils'
import {getChange} from '../../packages/Changes/Changes.selectors'
import {getCommiterName} from '../../packages/Changes/Changes.utils'

import {useAppSelector} from 'src/hooks/react-redux'

export const usePageTitle = (changeId: ChangeId): string | null => {
  const isAutodetectTimeZone = useIsAutodetectTimeZone()
  const change = useAppSelector(state => getChange(state, changeId))
  const {date} = change ?? {}

  const commiterName = getCommiterName(change)
  const formatedDate = date != null ? displayDate(date, isAutodetectTimeZone, true) : null

  if (change == null) {
    return null
  }

  return `${commiterName} change${formatedDate != null ? ` on ${formatedDate}` : null}`
}
